import { z } from 'zod';
import { BlockSchema } from './blocks';
import { UuidSchema } from './ids';
import { ConditionNodeSchema, LogicRuleSchema } from './logic';
import { TextContentSchema } from './richText';

export const FormStatusSchema = z.enum(['draft', 'published', 'closed', 'archived']);

export const FormSettingsSchema = z
  .object({
    show_progress: z.boolean().default(true),
    confirm_before_submit: z.boolean().default(true),
    submission_message: TextContentSchema.nullable().default(null),
    allow_back_navigation: z.boolean().default(false),
    collect_partial_answers: z.boolean().default(false),
  })
  .strict();
export type FormSettings = z.infer<typeof FormSettingsSchema>;

export const FormDefinitionSchema = z
  .object({
    schema_version: z.literal(1).default(1),
    form_id: UuidSchema,
    title: TextContentSchema,
    status: FormStatusSchema.default('draft'),
    draft_version: z.number().int().nonnegative(),
    current_published_revision_id: z.string().nullable().default(null),
    first_page_id: UuidSchema,
    ordered_root_block_ids: z.array(UuidSchema).default([]),
    blocks_by_id: z.record(UuidSchema, BlockSchema).default({}),
    condition_nodes_by_id: z.record(UuidSchema, ConditionNodeSchema).default({}),
    logic_rules_by_id: z.record(UuidSchema, LogicRuleSchema).default({}),
    settings: FormSettingsSchema.default(() => ({
      show_progress: true,
      confirm_before_submit: true,
      submission_message: null,
      allow_back_navigation: false,
      collect_partial_answers: false,
    })),
  })
  .strict();
export type FormDefinition = z.infer<typeof FormDefinitionSchema>;